module.exports = __webpack_public_path__ + "static/media/zoom_in.73a2508e.svg";